import Badge from "components/badge/Badge";
import { statusTone } from "lib/statusTone";

/**
 * Status pill for Heartbeat campaigns (active, inactive, draft).
 * A missing status reads as "Inactive", matching the backend default.
 */
const CampaignStatusBadge = ({ status, size = "md", className }) => {
  const value = status || "inactive";
  return (
    <Badge tone={statusTone(value)} size={size} dot className={className}>
      {value.charAt(0).toUpperCase() + value.slice(1)}
    </Badge>
  );
};

export default CampaignStatusBadge;
